import React from "react";
import { useTranslation } from "react-i18next";
import { Camera, Radio, AlertTriangle } from "lucide-react";

// Snapshot deep-link banner. States plainly when the frame is NOT current
// (the Run is still live) or when the requested sequence isn't on the record.
export default function SnapshotBanner({ sequence, notice, classification, onOpenLive }) {
  const { t } = useTranslation();
  return (
    <div className="absolute top-4 right-4 max-w-sm rounded-xl bg-[var(--qn-glass)] backdrop-blur border border-[var(--qn-border)] px-4 py-3 text-left"
      data-testid="dg-snapshot-banner" data-notice={notice || "current"}>
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.18em] text-[var(--qn-primary)]">
        <Camera className="w-3.5 h-3.5" />{t("decisionGraph.snapshot.label", { seq: sequence })}
        {classification === "demo" && (
          <span className="ml-1 rounded border border-[var(--qn-border)] px-1.5 py-0.5 text-[9px] tracking-normal text-[var(--qn-foreground-subtle)]" data-testid="dg-snapshot-demo-tag">
            {t("decisionGraph.chips.demoData")}
          </span>
        )}
      </div>
      {notice === "live_continued" && (
        <div className="mt-2 flex items-start gap-2 text-xs text-[var(--qn-foreground)]" data-testid="dg-snapshot-live-notice">
          <Radio className="w-3.5 h-3.5 mt-0.5 text-[var(--qn-error)] shrink-0" />
          <div>
            {t("decisionGraph.snapshot.liveContinued")}
            <button onClick={onOpenLive} data-testid="dg-snapshot-open-live"
              className="ml-1 underline text-[var(--qn-primary)] hover:text-[var(--qn-primary-hover)] focus:outline-none focus:ring-2 focus:ring-[var(--qn-primary)] rounded">
              {t("decisionGraph.snapshot.openLive")}
            </button>
          </div>
        </div>
      )}
      {notice === "frame_missing" && (
        <div className="mt-2 flex items-start gap-2 text-xs text-[var(--qn-foreground-muted)]" data-testid="dg-snapshot-missing-notice">
          <AlertTriangle className="w-3.5 h-3.5 mt-0.5 shrink-0" />{t("decisionGraph.snapshot.frameMissing")}
        </div>
      )}
      {!notice && <div className="mt-1 text-xs text-[var(--qn-foreground-muted)]">{t("decisionGraph.snapshot.frozen")}</div>}
    </div>
  );
}
